import { useEffect, useState } from 'react';

const getBottomInset = () => {
    if (typeof window === 'undefined' || !window.visualViewport) {
        return 0;
    }

    const { height, offsetTop } = window.visualViewport;
    return Math.max(0, Math.round(window.innerHeight - height - offsetTop));
};

/**
 * Отступ снизу под панель браузера / home bar на Android Chrome и iOS Safari.
 * env(safe-area-inset-bottom) в обычном браузере часто = 0 без viewport-fit=cover.
 */
export const useVisualViewportBottomInset = (enabled) => {
    const [inset, setInset] = useState(0);

    useEffect(() => {
        if (!enabled) {
            setInset(0);
            return undefined;
        }

        const update = () => setInset(getBottomInset());

        update();

        const vv = window.visualViewport;
        if (vv) {
            vv.addEventListener('resize', update);
            vv.addEventListener('scroll', update);
        }
        window.addEventListener('resize', update);
        window.addEventListener('orientationchange', update);

        return () => {
            if (vv) {
                vv.removeEventListener('resize', update);
                vv.removeEventListener('scroll', update);
            }
            window.removeEventListener('resize', update);
            window.removeEventListener('orientationchange', update);
        };
    }, [enabled]);

    return inset;
};
